var strictUriEncode;
var hasRequiredStrictUriEncode;

function requireStrictUriEncode () {
	if (hasRequiredStrictUriEncode) return strictUriEncode;
	hasRequiredStrictUriEncode = 1;
	strictUriEncode = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};
	return strictUriEncode;
}

export { requireStrictUriEncode as __require };
//# sourceMappingURL=index.js.map
